import { useEffect, useState } from "react"

export function useMediaQuery(query: string) {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window !== "undefined" && "matchMedia" in window) {
      return window.matchMedia(query).matches
    }
    return false
  })

  useEffect(() => {
    if (typeof window === "undefined" || !("matchMedia" in window)) return

    const media = window.matchMedia(query)
    function listener() {
      setMatches(media.matches)
    }

    // Set the initial value and subscribe for changes
    listener()
    if (media.addEventListener) {
      media.addEventListener("change", listener)
      return () => media.removeEventListener("change", listener)
    }
    // Fallback for older browsers
    media.addListener(listener)
    return () => media.removeListener(listener)
  }, [query])

  return matches
}
